<div class="user-permissions-component">
  <div class="permission-search">
    <app-search-input
      [(ngModel)]="localSearchString"
      [disabled]="isLocalSearchDisabled"
      [placeholder]="
        isLocalSearchDisabled
          ? 'Global search active'
          : 'Type to filter the list of effective user permissions'
      "
    ></app-search-input>
  </div>
  <div class="permissions-container">
    @for (roleModule of userModules$ | async; track roleModule) {
      <div
        class="permissions-holder"
        [class.d-none]="shouldHideModule(roleModule, activeSearchString)"
      >
        <div
          class="module-holder root"
          [class.d-none]="shouldHideModule(roleModule, activeSearchString)"
        >
          @if (roleModule?.root_component) {
            <div class="module-box">
              @if (roleModule?.root_component.selected) {
                <fa-icon class="tick" [icon]="['fas', 'check']" />
              }
              @if (!roleModule?.root_component.selected) {
                <fa-icon class="x" [icon]="['fas', 'x']" />
              }
              <div
                class="role-module-name"
                [innerHTML]="roleModule.name | highlight: activeSearchString"
              ></div>
            </div>
          }
        </div>
        @for (component of roleModule.components; track component) {
          <div
            [class.d-none]="
              shouldHideComponent(roleModule, component, activeSearchString)
            "
          >
            <div class="module-holder component-box">
              @if (component.selected) {
                <fa-icon class="tick" [icon]="['fas', 'check']" />
              }
              @if (!component.selected) {
                <fa-icon class="x" [icon]="['fas', 'x']" />
              }
              <div
                class="component-name"
                [innerHTML]="component.name | highlight: activeSearchString"
              ></div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
